import { createUseStyles } from 'react-jss';
import { SidebarType } from './sidebar-type.enum';

export const useSidebarStyles = (type: SidebarType) => {
  const translateX =
    type === SidebarType.LEFT ? 'translateX(-350px)' : 'translateX(350px)';

  return createUseStyles({
    'menu-transition': {
      transition: 'transform 250ms ease-in',
      transform: `${translateX}`,
      '&.menu-transition-enter-active, &.menu-transition-enter-done': {
        transform: 'translateX(0px)',
      },
      '&.menu-transition-leave-active': {
        transform: `${translateX}`,
      },
    },
    'bg-layer-transition': {
      transition: 'opacity 250ms',
      opacity: 0,
      '&.bg-layer-transition-enter-active, &.bg-layer-transition-enter-done': {
        opacity: 0.5,
      },
      '&.bg-layer-transition-leave-active': {
        opacity: 0,
      },
    },
  });
};
